import { Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { defer, Observable, of } from 'rxjs';
import { catchError, map, shareReplay, startWith, timeout } from 'rxjs/operators';
import { LocalizationActions } from '../store/localization.action';

const FIRST_PAINT_LANGUAGE_TIMEOUT_MS = 5000;

@Injectable()
export class TranslationsReadyService {
  // The app shell renders once this is true, so no raw keys show; a slow or failed load never holds it back.
  public readonly translationsReady$: Observable<boolean> = defer(() => {
    // Creating the root TranslateService registers it and dispatches LoadLanguage; before that there is nothing to load into.
    this.injector.get(TranslateService);
    return this.store.dispatch(new LocalizationActions.LoadFirstPaintLanguage());
  }).pipe(
    timeout({ first: FIRST_PAINT_LANGUAGE_TIMEOUT_MS }),
    catchError(() => of(undefined)),
    map(() => true),
    startWith(false),
    shareReplay(1),
  );

  public constructor(
    private readonly store: Store,
    private readonly injector: Injector,
  ) {}
}
